
import axiosInstance from '../../config/axios';
import type { APIResp } from '../../types/APIService';

export type NewsType = 'important' | 'normal';

export type News = {
	id: number;
	title: string;
	description: string;
	type: NewsType;
	created_at: number;
}

const API_ROUTE = 'news';

export async function getAllNews(): Promise<News[]> {
	try {
		const res = await axiosInstance.get<APIResp<News[]>>(API_ROUTE);
		return res.data.data;
	}
	catch {
		return [];
	}
}

export async function postNews(body: Omit<News, 'id' | 'created_at'>): Promise<boolean> {
	try {
		await axiosInstance.post(API_ROUTE, body);
		return true;
	}
	catch {
		return false;
	}
}

export async function putNews({ id, ...body }: News): Promise<boolean> {
	try {
		await axiosInstance.put(`${API_ROUTE}/${id}`, body);
		return true;
	}
	catch {
		return false;
	}
}

export async function delNews(id: number): Promise<boolean> {
	try {
		await axiosInstance.delete(`${API_ROUTE}/${id}`);
		return true;
	}
	catch {
		return false;
	}
}

export async function bulkUpdateNews(ids: number[]): Promise<boolean> {
	try {
		await axiosInstance.post(`${API_ROUTE}/bulk-update`, ids);
		return true;
	}
	catch {
		return false;
	}
}
